import React from "react";
import PropTypes from "prop-types";
import { ALL, getMonthOptions, getYearOptions } from "./pnlReportUtils";

const PnLFilters = ({
  filters,
  categoryOptions,
  typeOptions,
  errorMessage,
  disabled,
  onChange,
  onApply,
  onClear,
}) => {
  const handleChange = (field) => (event) => onChange(field, event.target.value);
  const monthOptions = getMonthOptions(filters.year);

  return (
    <div className="pnl-filters">
      <div className="pnl-field">
        <label htmlFor="pnl-year">Year</label>
        <select id="pnl-year" value={filters.year} onChange={handleChange("year")}>
          {getYearOptions().map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>
      <div className="pnl-field">
        <label htmlFor="pnl-from">From month</label>
        <select id="pnl-from" value={filters.fromMonth} onChange={handleChange("fromMonth")}>
          {monthOptions.map((month) => (
            <option key={month.value} value={month.value}>{month.label}</option>
          ))}
        </select>
      </div>
      <div className="pnl-field">
        <label htmlFor="pnl-to">To month</label>
        <select
          id="pnl-to"
          value={filters.toMonth}
          onChange={handleChange("toMonth")}
          aria-invalid={Boolean(errorMessage)}
          aria-describedby={errorMessage ? "pnl-filter-error" : undefined}
        >
          {monthOptions.map((month) => (
            <option key={month.value} value={month.value}>{month.label}</option>
          ))}
        </select>
        {errorMessage && <div id="pnl-filter-error" className="pnl-filter-error" role="alert">{errorMessage}</div>}
      </div>
      <div className="pnl-field">
        <label htmlFor="pnl-category">Category</label>
        <select id="pnl-category" value={filters.category} onChange={handleChange("category")}>
          <option value={ALL}>All categories</option>
          {categoryOptions.map((category) => (
            <option key={category.value} value={category.value}>{category.label}</option>
          ))}
        </select>
      </div>
      <div className="pnl-field">
        <label htmlFor="pnl-type">Type</label>
        <select id="pnl-type" value={filters.subType} onChange={handleChange("subType")}>
          <option value={ALL}>All types</option>
          {typeOptions.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>
      <div className="pnl-filter-buttons">
        <button type="button" className="btn cus-seconday-bg-btn" onClick={onApply} disabled={disabled}>
          Apply filter
        </button>
        <button type="button" className="btn cus-primary-transparent-btn" onClick={onClear} disabled={disabled}>
          Clear filter
        </button>
      </div>
    </div>
  );
};

PnLFilters.propTypes = {
  filters: PropTypes.shape({
    year: PropTypes.number.isRequired,
    fromMonth: PropTypes.number.isRequired,
    toMonth: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
    subType: PropTypes.string.isRequired,
  }).isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ).isRequired,
  typeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default PnLFilters;
